import { render, staticRenderFns } from "./roleManagerList.vue?vue&type=template&id=5b8346db"
import script from "./roleManagerList.vue?vue&type=script&lang=js"
export * from "./roleManagerList.vue?vue&type=script&lang=js"
import style0 from "./roleManagerList.vue?vue&type=style&index=0&id=5b8346db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports